// AUTO-GENERATED z Notion DB "DAIEN Blog CMS" przez scripts/fetch-blog-from-notion.mjs
// Nie edytuj recznie - zmiany pisz w Notion, build pobierze swieze.

import type { PostMeta } from './registry';

export const meta: PostMeta = {
    "slug": "voice-agent-case-study-deweloperka",
    "title": "Voice agent dla firmy deweloperskiej - z chaosu Excela do automatu n8n + Pipedrive",
    "date": "2026-05-08",
    "excerpt": "Jak wdrozylem voice agenta do umawiania spotkan w firmie budowlanej z 35h oszczednosci tygodniowo. Stack, trade-offy, rzeczy ktore sie zepsuly.",
    "tags": [
      "Case Study",
      "Voice AI",
      "n8n"
    ],
    "readTime": 8
  };

export function Body() {
  return (
    <>
      <p>Klient to sredniej wielkosci firma deweloperska z Trojmiasta - 12 pracownikow biurowych, ~200 leadow inbound miesiecznie. Przed wdrozeniem miala chroniczny problem: leady czekaly 24-48h na pierwszy kontakt, czesc 'stygla' zanim ktos oddzwonil.</p>
      <h2>Diagnoza</h2>
      <p>Po dwoch godzinach rozmow z kierownikiem sprzedazy i 30 minutach grzebania w ich Pipedrive zobaczylem:</p>
      <ul>
        <li>43% leadow dostawalo pierwszy kontakt po 24h+</li>
        <li>Asystentka biurowa tracila ~5h dziennie na umawianie i przekladanie spotkan przez telefon</li>
        <li>Excel z dyzurami doradcow byl edytowany przez 3 osoby - kolizje srednio 2x/tydzien</li>
      </ul>
      <h2>Stack</h2>
      <p>Wybor po krotkim spike na 3 alternatywach:</p>
      <ul>
        <li><strong>Voice:</strong> Retell.ai (lepszy latency niz Vapi w tescie EU) + ElevenLabs (glos PL, klient odrozanial od Polly)</li>
        <li><strong>Brain:</strong> Claude Sonnet 4.6 z system promptem opartym o playbook sprzedazowy klienta</li>
        <li><strong>Orkiestracja:</strong> n8n self-hosted (Docker na Hetznerze) - workflow: lead webhook -&gt; AI quality gate -&gt; Pipedrive insert -&gt; Calendar slot search -&gt; Voice agent call</li>
        <li><strong>CRM:</strong> Pipedrive (juz mieli) + custom field 'AI score 1-10' do priorytyzacji</li>
      </ul>
      <h2>Co poszlo nie tak</h2>
      <p>Pierwsza wersja agenta zatwierdzala kazde spotkanie bez sprawdzania czy doradca jest w biurze. Po 4 dniach klient zglosil, ze dwie osoby przyjechaly, a doradcy byli na spotkaniu w terenie. Fix: dodanie integracji z Google Calendar w workflow (sprawdzanie wolnych slotow per doradca + automatyczne przepinanie).</p>
      <p>Druga sprawa: ElevenLabs voice w polskim brzmial swietnie, ale przy szybkiej mowie klienta robil hallucinations w transkrypcji ('Nowowiejska' -&gt; 'Nowo Wiejka'). Rozwiazanie: switch na Whisper large-v3 jako STT zamiast wbudowanego w Retell + warstwa correction promptem.</p>
      <h2>Wyniki po 3 miesiacach</h2>
      <ul>
        <li>Pierwszy kontakt z leadem: <strong>srednio 8 minut</strong> (bylo 24-48h)</li>
        <li>Conversion lead -&gt; spotkanie: <strong>+34%</strong></li>
        <li>Czas asystentki na umawianie: <strong>~5h dziennie -&gt; ~30 min</strong> (35h oszczednosci tygodniowo)</li>
        <li>Koszt infry: ~1 200 PLN/m-c (Retell + ElevenLabs + Hetzner + Anthropic)</li>
        <li>ROI breakeven: 2 miesiace</li>
      </ul>
      <h2>Co bym zrobil inaczej</h2>
      <p>Spike na ElevenLabs vs ClonedVoice (od OpenAI) zajalbym 2 dni zamiast poltora - cloned voice bylby tanszy i mial lepszy 'follow-up' dla pytan 'czy mozemy sie umowic jutro' gdzie kontekst rozmowy jest dlugi. Druga rzecz: od razu zrobilbym dashboard z lead quality score zamiast czekac miesiac na feedback klienta.</p>
    </>
  );
}
